module.exports = __webpack_public_path__ + "v1.8.4.20261010/img/008.2a50f47c.png";